import React from "react";
import { Link } from "react-scroll";
import Typewriter from "typewriter-effect";
import { scrollDuration } from "../../config/commonConfig";
import aboutData from "../../data/about.json";

const {
  headline,
  typewriter_strings,
  tagline,
  hero_cta_text,
  hero_cta_target,
  profile_image,
  name,
  hero_bottom_title,
} = aboutData;

export const ProfileImage = ({
  className = "img-fluid rounded-pill d-block",
  wrapperClassName = "bg-light rounded-pill d-inline-block p-4 shadow-lg wow zoomIn",
}) => (
  <div className={wrapperClassName}>
    <img className={className} src={profile_image} title={name} alt={name} />
  </div>
);

export const HeroHeadline = ({ as: Tag = "h1", className = "text-12 fw-300 mb-0 text-uppercase" }) => (
  <Tag className={className}>{headline}</Tag>
);

export const HeroTypewriter = ({ className = "text-18 fw-600 text-uppercase mb-0 ms-n1" }) => (
  <h2 className={className}>
    <Typewriter
      options={{
        strings: typewriter_strings,
        autoStart: true,
        loop: true,
      }}
    />
  </h2>
);

export const HeroTagline = ({ className = "text-5" }) => (
  <p className={className}>{tagline}</p>
);

export const HeroCta = ({
  className = "btn btn-dark rounded-0 smooth-scroll mt-3",
}) => (
  <Link
    className={className}
    smooth="easeInOutQuint"
    duration={scrollDuration}
    style={{ cursor: "pointer" }}
    to={hero_cta_target}
  >
    {hero_cta_text}
  </Link>
);

export const HeroBottomTitle = ({
  className = "text-10 text-uppercase fw-600 mb-4 wow fadeInUp",
}) => <h2 className={className}>{hero_bottom_title}</h2>;
